import { useMutation, useQueryClient } from 'react-query';
import toast from '../../../Components/Toast/Toast';
import ItemServiceApi, { VendorSendDetails } from '../../Api/item-service';

type SubmitItemsDetailsParams = {
  userId: string;
  itemId: string;
  itemDetails: VendorSendDetails;
};

export const useSubmitItemDetails = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: SubmitItemsDetailsParams) =>
      ItemServiceApi.submitItemDetails(
        params.userId,
        params.itemId,
        params.itemDetails,
      ),
    {
      onSuccess: async (_, { userId, itemId }) => {
        await queryClient.invalidateQueries([
          'item-service-vendor-catalog-item',
          userId,
          itemId,
        ]);
        toast(`Item details succesfully sent`, {
          type: 'success',
        });
      },
      onError: (error) => {
        toast({ title: 'Error submitting item.' }, { type: 'error' });
        console.error('error while submtting the item', error);
      },
    },
  );
};
